import {Component, Input} from "@angular/core";
import {DxNavigationTreeNode} from "../../../../../domain/navigator/dx-navigation-tree-node";

@Component({
  selector: 'dx-side-dropdown-tree',
  templateUrl: './dx-side-dropdown-tree.component.html',
  styleUrls: ['./dx-side-dropdown-tree.component.css']
})
export class DxSideDropdownTreeComponent {
  /** Узел первого уровня навигационного меню, являющийся корнем ветки для данного пункта */
  private _menuNode: DxNavigationTreeNode;

  constructor() {}

  @Input()
  set menuNode(value: DxNavigationTreeNode) {
    this._menuNode = value;
  }
}
